import { IconPaymentMethodsAccelSmall, IconPaymentMethodsAchSmall, IconPaymentMethodsAlipayCnSmall, IconPaymentMethodsAlipayHkSmall, IconPaymentMethodsAlipaySmall, IconPaymentMethodsAlmaSmall, IconPaymentMethodsAmexSmall, IconPaymentMethodsAstroSmall, IconPaymentMethodsBancontactSmall, IconPaymentMethodsBankAccountSmall, IconPaymentMethodsBenefitpay, IconPaymentMethodsBenefitpgSmall, IconPaymentMethodsBizumSmall, IconPaymentMethodsBoletoSmall, IconPaymentMethodsCarteBancaireSmall, IconPaymentMethodsDanaSmall, IconPaymentMethodsDciSmall, IconPaymentMethodsDiscoverSmall, IconPaymentMethodsEnetsSmall, IconPaymentMethodsEpsSmall, IconPaymentMethodsFawrySmall, IconPaymentMethodsGcashSmall, IconPaymentMethodsGiropaySmall, IconPaymentMethodsIdealSmall, IconPaymentMethodsJcbSmall, IconPaymentMethodsKakaopaySmall, IconPaymentMethodsKlarnaSmall, IconPaymentMethodsKnetSmall, IconPaymentMethodsMadaSmall, IconPaymentMethodsMaestroSmall, IconPaymentMethodsMastercardSmall, IconPaymentMethodsMbwaySmall, IconPaymentMethodsMultibancoSmall, IconPaymentMethodsNyceSmall, IconPaymentMethodsOctopusSmall, IconPaymentMethodsOmannetSmall, IconPaymentMethodsOxxoSmall, IconPaymentMethodsPaypalSmall, IconPaymentMethodsPaynowSmall, IconPaymentMethodsPixSmall, IconPaymentMethodsPlaceholderSmall, IconPaymentMethodsPlaidSmall, IconPaymentMethodsPoliSmall, IconPaymentMethodsPostfinanceSmall, IconPaymentMethodsPrzelewy24Small, IconPaymentMethodsPulseSmall, IconPaymentMethodsQiwiSmall, IconPaymentMethodsQpaySmall, IconPaymentMethodsSafetypaySmall, IconPaymentMethodsSepaSmall, IconPaymentMethodsSequraSmall, IconPaymentMethodsSofortSmall, IconPaymentMethodsStarSmall, IconPaymentMethodsStcpaySmall, IconPaymentMethodsTabbySmall, IconPaymentMethodsTamaraSmall, IconPaymentMethodsTenpaySmall, IconPaymentMethodsTnGSmall, IconPaymentMethodsTruemoneySmall, IconPaymentMethodsTwintSmall, IconPaymentMethodsUnionpaySmall, IconPaymentMethodsVisaSmall, IconPaymentMethodsWechatSmall, } from '@cko/icons';
const iconSchemes = {
    ACCEL: IconPaymentMethodsAccelSmall,
    ACH: IconPaymentMethodsAchSmall,
    ALIPAY_CN: IconPaymentMethodsAlipayCnSmall,
    ALIPAY_HK: IconPaymentMethodsAlipayHkSmall,
    ALIPAY: IconPaymentMethodsAlipaySmall,
    ALMA: IconPaymentMethodsAlmaSmall,
    AMEX: IconPaymentMethodsAmexSmall,
    ASTROPAYCC: IconPaymentMethodsAstroSmall,
    BANCONTACT: IconPaymentMethodsBancontactSmall,
    BANK: IconPaymentMethodsBankAccountSmall,
    BENEFIT: IconPaymentMethodsBenefitpgSmall,
    BENEFITPAY: IconPaymentMethodsBenefitpay,
    BIZUM: IconPaymentMethodsBizumSmall,
    BOLETO: IconPaymentMethodsBoletoSmall,
    CARTES_BANCAIRES: IconPaymentMethodsCarteBancaireSmall,
    DANA: IconPaymentMethodsDanaSmall,
    DCI: IconPaymentMethodsDciSmall,
    DINERSCLUB: IconPaymentMethodsDciSmall,
    DISCOVER: IconPaymentMethodsDiscoverSmall,
    ENETS: IconPaymentMethodsEnetsSmall,
    EPS: IconPaymentMethodsEpsSmall,
    FAWRY: IconPaymentMethodsFawrySmall,
    GCASH: IconPaymentMethodsGcashSmall,
    GIROPAY: IconPaymentMethodsGiropaySmall,
    IDEAL: IconPaymentMethodsIdealSmall,
    JCB: IconPaymentMethodsJcbSmall,
    KAKAOPAY: IconPaymentMethodsKakaopaySmall,
    KLARNA: IconPaymentMethodsKlarnaSmall,
    KNET: IconPaymentMethodsKnetSmall,
    MADA: IconPaymentMethodsMadaSmall,
    MAESTRO: IconPaymentMethodsMaestroSmall,
    MASTERCARD: IconPaymentMethodsMastercardSmall,
    MBWAY: IconPaymentMethodsMbwaySmall,
    MULTIBANCO: IconPaymentMethodsMultibancoSmall,
    NYCE: IconPaymentMethodsNyceSmall,
    OCTOPUS: IconPaymentMethodsOctopusSmall,
    OMANNET: IconPaymentMethodsOmannetSmall,
    OXOO: IconPaymentMethodsOxxoSmall,
    P24: IconPaymentMethodsPrzelewy24Small,
    PAYPAL: IconPaymentMethodsPaypalSmall,
    PAYNOW: IconPaymentMethodsPaynowSmall,
    PIX: IconPaymentMethodsPixSmall,
    PLACEHOLDER: IconPaymentMethodsPlaceholderSmall,
    PLAID: IconPaymentMethodsPlaidSmall,
    POLI: IconPaymentMethodsPoliSmall,
    POSTFINANCE: IconPaymentMethodsPostfinanceSmall,
    PULSE: IconPaymentMethodsPulseSmall,
    QIWI: IconPaymentMethodsQiwiSmall,
    QPAY: IconPaymentMethodsQpaySmall,
    SAFETYPAY: IconPaymentMethodsSafetypaySmall,
    SEPA: IconPaymentMethodsSepaSmall,
    SEQURA: IconPaymentMethodsSequraSmall,
    SOFORT: IconPaymentMethodsSofortSmall,
    STAR: IconPaymentMethodsStarSmall,
    STCPAY: IconPaymentMethodsStcpaySmall,
    TABBY: IconPaymentMethodsTabbySmall,
    TAMARA: IconPaymentMethodsTamaraSmall,
    TENPAY: IconPaymentMethodsTenpaySmall,
    TNG: IconPaymentMethodsTnGSmall,
    TRUEMONEY: IconPaymentMethodsTruemoneySmall,
    TWINT: IconPaymentMethodsTwintSmall,
    UNIONPAY: IconPaymentMethodsUnionpaySmall,
    UPI: IconPaymentMethodsUnionpaySmall,
    VISA: IconPaymentMethodsVisaSmall,
    WECHATPAY: IconPaymentMethodsWechatSmall,
};
export default iconSchemes;
